module.exports = __webpack_public_path__ + "static/media/Alert.d24b26b6.svg";